import { Box, SvgIcon } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { ReactComponent as LeftArrowIcon } from '../assets/svg/left_arrow.svg';

export default function UserPolicy() {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
      }}
    >
      <div className="flex w-full h-40 bg-bg-primary  pt-8 justify-between  px-9">
        <div>
          <button onClick={goBack}>
            <SvgIcon
              component={LeftArrowIcon}
              inheritViewBox
              sx={{ fontSize: '32px' }}
              className="text-bg-primary"
            ></SvgIcon>
          </button>
        </div>
        <p className="text-ti !font-futura  text-bg-white font-semibold">
          User Terms
        </p>
        <p className="place-self-end mb-2 w-[32px]"></p>
      </div>
      <div className="absolute top-24 w-full px-9">
        <div className="bg-bg-white w-full rounded-3xl shadow-md pt-12 pb-16">
          <div className="px-6 flex-row jutify-center items-center">
            <div className="text-base mt-2 font-medium">
              <p className="text-ti font-semibold !font-futura text-center font-semibold">
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                User Policy and Terms of Use
              </p>
              {/* <p className="text-lg my-2">
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                User Policy and Terms of Use
              </p> */}
              <p className="my-2">Last Updated: [October 25, 2023]</p>
              <p className="my-2">
                Welcome to{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                ! Please read these User Policy and Terms of Use ("Terms")
                carefully before using our website and services. By accessing or
                using{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , you agree to comply with and be bound by these Terms. If you
                do not agree to these Terms, please do not use our services.
              </p>
              <p className="text-lg my-2">1. Acceptance of Terms</p>
              <p className="my-2">
                By accessing or using{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , you confirm that you have read, understood, and agreed to be
                bound by these Terms, including any future modifications. If you
                do not agree to these Terms, you are not permitted to use{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                .
              </p>
              <p className="text-lg my-2">2. Use of Services</p>
              <p className="my-2">
                By accessing or using{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , you confirm that you have read, understood, and agreed to be
                bound by these Terms, including any future modifications. If you
                do not agree to these Terms, you are not permitted to use{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                .
              </p>
              <p className="my-2">2.1. AI-Generated Content</p>
              <p className="my-2">
                Some content provided on{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , including answers to user queries, may be generated by
                artificial intelligence ("AI"). While we strive to ensure the
                accuracy and reliability of AI-generated content, we cannot
                guarantee its correctness or completeness. Users are advised to
                use AI-generated content responsibly and at their own risk.
              </p>
              <p className="text-lg my-2">3. User Conduct</p>
              <p className="my-2">
                Users are expected to use{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                responsibly and ethically. Prohibited conduct includes, but is
                not limited to, posting of offensive, harmful, or misleading
                content, impersonating others, infringing on intellectual
                property rights, and engaging in illegal activities. We reserve
                the right to remove content and suspend or terminate user
                accounts that violate these Terms.
              </p>
              <p className="text-lg my-2">4. Privacy and Data Protection</p>
              <p className="my-2">
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                is committed to protecting the privacy and security of user
                data. We collect, store, and use user data in accordance with
                our Privacy Policy. By using{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , you consent to our collection, use, and sharing of your data
                as described in the Privacy Policy.
              </p>
              <p className="my-2">4.1. Use of Data to Improve Services</p>
              <p className="my-2">
                We use the data collected from users to improve our services,
                develop new features, and provide personalized recommendations.
                We may also share user data with third parties for these
                purposes, ensuring that such third parties adhere to our data
                protection standards.
              </p>
              <p className="text-lg my-2">5. Intellectual Property</p>
              <p className="my-2">
                All content on{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>
                , including text, graphics, logos, and software, is the property
                of{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                or its licensors and is protected by Canadian and international
                intellectual property laws. Users are granted a limited license
                to access and use our services for personal, non-commercial
                purposes, in accordance with these Terms.
              </p>
              <p className="text-lg my-2">
                6. Disclaimers and Limitation of Liability
              </p>
              <p className="my-2">
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                and its services are provided "as is" and "as available" without
                any warranties of any kind, either express or implied. We do not
                guarantee that our services will be uninterrupted, secure, or
                error-free.{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                shall not be liable for any indirect, incidental, or
                consequential damages arising out of or in connection with these
                Terms or the use of our services.
              </p>
              <p className="text-lg my-2">7. Modifications to Terms</p>
              <p className="my-2">
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                reserves the right to modify these Terms at any time. We will
                notify users of any changes by posting the updated Terms on our
                website. Continued use of our services following such
                modifications indicates your acceptance of the revised Terms.
              </p>
              <p className="text-lg my-2">8. Governing Law</p>
              <p className="my-2">
                These Terms are governed by the laws of Canada, without regard
                to its conflict of law principles. Any disputes arising out of
                or in relation to these Terms shall be subject to the exclusive
                jurisdiction of the courts of Canada.
              </p>
              <p className="text-lg my-2">9. Contact Us</p>
              <p className="my-2">
                If you have any questions or concerns about these Terms, please
                contact us at{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai/contactus"
                >
                  {` Contact Us `}
                </a>
                . Thank you for being a part of the{' '}
                <a
                  className="text-text-hyperlink underline"
                  href="https://www.rcpilots.ai"
                >
                  {` RCPC.ai `}
                </a>{' '}
                community! We look forward to serving RC pilots across Canada
                and helping to foster a supportive and informative community for
                all.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
